import { render, staticRenderFns } from "./FSCaseAccordion.vue?vue&type=template&id=6383fbbf&"
import script from "./FSCaseAccordion.vue?vue&type=script&lang=js&"
export * from "./FSCaseAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports